<span class="comma-separated">
  <span *ngFor="let item of summary" class="font-body-2 regular-type ps-xxsmall-b">
    <span *ngIf="item.quantity">{{ item.quantity }} x </span>
    {{ item.description }}
  </span>
</span>
